import React from "react";
import { Card, CardMedia, CardContent, Typography, Avatar, Box, IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { UserProfileCardData } from "../../../services/directoryService";
import styles from "./ProfileCard.module.scss";
import defaultBannerImage from "../../../assets/images/aspire-profile-background.png";

interface ProfileCardProps {
    user: UserProfileCardData;
    disableHover?: boolean;
}

const ProfileCard: React.FC<ProfileCardProps> = ({ user, disableHover = false }) => {
    // Use safe defaults with optional chaining
    const {
        id = "",
        name = "Sample User",
        location = "",
        profileImageUrl,
        bannerImageUrl,
        title = "",
        linkedinURL,
        // aboutSnippet,
    } = user || {};

    // console.log("linkedinURL", linkedinURL);
    console.log("user", user);

    // Hardcoded data to match the screenshot, as it's not available in the API
    const userTitle = title;
    // const connections = "275 Connections";
    const socialLinks = {
        facebook: "https://facebook.com",
        instagram: "https://instagram.com",
        linkedin: "https://linkedin.com",
    };
    const userProfileImageUrl = "https://i.imgur.com/V4RclNb.png"; // Placeholder

    const defaultBanner = `linear-gradient(45deg, #9f8f5e 0%, #b7a97f 50%, #9f8f5e 100%)`;

    // Combine class names conditionally
    const cardClassName = `${styles.card} ${disableHover ? styles.noHover : ""}`;

    return (
        <Card
            className={cardClassName}
            component={disableHover ? "div" : Link}
            to={`/profile/${id}`}
            tabIndex={0}
            aria-label={`Profile for ${name}`}
        >
            {/* Banner image */}
            <CardMedia
                component="div"
                className={styles.banner}
                sx={{
                    height: "120px",
                    background: bannerImageUrl
                        ? `url(${bannerImageUrl})`
                        : `url(${defaultBannerImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            />

            {/* Profile image */}
            <Box className={styles.avatarContainer}>
                <Avatar
                    src={profileImageUrl || userProfileImageUrl}
                    alt={name}
                    className={styles.avatar}
                    sx={{ width: 140, height: 140 }}
                />
            </Box>

            {/* Card content */}
            <CardContent
                className={`${styles.content} ${linkedinURL ? styles.contentWithSocial : ""}`}
            >
                <Typography variant="h5" component="h3" className={styles.name}>
                    {name}
                </Typography>

                {location && (
                    <Typography variant="body2" className={styles.location}>
                        {location || ""}
                    </Typography>
                )}

                <Typography variant="body1" className={styles.title}>
                    {userTitle || ""}
                </Typography>

                {/* <Typography variant="body2" className={styles.connections}>
                    {connections}
                </Typography> */}

                {linkedinURL && (
                    <Box className={styles.socialIcons}>
                        <IconButton
                            component="a"
                            href={linkedinURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="LinkedIn Profile"
                            onClick={(e) => {
                                // Prevent the card's Link navigation from firing
                                e.preventDefault();
                                e.stopPropagation();
                                window.open(linkedinURL, "_blank", "noopener,noreferrer");
                            }}
                        >
                            <LinkedInIcon sx={{ color: "#0077b5" }} />
                        </IconButton>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default ProfileCard;
